export enum BuySell {
  BUY = 'BUY',
  SELL = 'SELL',
}
